var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"id":_vm.id,"title":_vm.title}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.politica)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }